import React, { Component } from 'react';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Footer2 from '../../Shared/Footer2';
import DropDownTable from '../../Shared/DropDownTable';
import '../../../css/PreAdvise/CreateAddHazard.css';
import Input from '../../Shared/Input';
import Button from '../../Shared/Button';
import arrowUp from '../../../Assets/ProfileManagement/Assets-Desktop/arrow-up.svg';
import downarrow from '../../../Assets/ProfileManagement/Assets-Desktop/arrow-down.svg';
import rightarrow from '../../../Assets/ContainerStatus/Assets_Desktop/arrow-right-medium.svg';
import search from '../../../Assets/TruckVisits/Assets-Desktop/search-icon.svg';
import uncheckedbox from '../../../Assets/ProfileManagement/Assets-Desktop/checkbox-checked.svg';
import checkedbox from '../../../Assets/TruckVisits/Assets-Desktop/unchecked-box.svg';
import optionalFieldDown from '../../../Assets/TruckVisits/Assets/dropdown.svg';
import optionalFieldup from '../../../Assets/TruckVisits/Assets/dropdown-up.svg';
import Message from '../../../Data/Shared/Message.json';
import ColorCode from '../../../Data/Shared/ColorCode.json';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
class CreateAddHazard extends Component {
    constructor(props) {
        super(props)
        this.container = React.createRef();
        this.state = {
            optionalField: false,
            UNNANo: '',
            ProperName: '',
            TechnicalName: '',
            Notes: '',
            Quantity: '',
            ExplosiveClass: '',
            EmergencyContact: '',
            InhalationZone: '',
            MFAG: '',
            SubstanceIDLowerPart: '',
            MoveMethod: '',
            IMO2: '',
            IMDGClass: '',
            HAZARDNoType: 'United Nations (UN)',
            PackingGroup: '',
            LimitedQuantitycheckbox: false,
            MarinePollutantscheckbox: false,
            IMDGClassdropdown: false,
            HAZARDNoTypedropdown: false,
            PackingGroupdropdown: false,
            IMDGClassdata: [],
            HAZARDNoTypedata: [],
            PackingGroupdata: [],
            errors: {},
            PackageType: '',
            Weight: '',
            FlashPoint: '',
            EmergencyResponseGuideNo: '',
            IMDGPageNo: '',
            DcLgRef: '',
            EMS: '',
            HazardIDUpperPart: '',
            PlannedReferenceNo: '',
            DeckRestrictions: '',
            FireCode: '',
            IMO1: '',
            IMO1dropdown: false,
            firecodedropdown: false,
            firecodedata: [{ name: "dca" }, { name: "abc" }, { name: "bcd" }],
            searchfirecodelength: 0,
            firecodedata1: [],
            IMO1data: [],
        }
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }
    componentDidMount = () => {
        document.addEventListener("mousedown", this.handleClickOutside);
    }
    preAdvice = () => {
        this.props.history.push("/home");
    }
    handleClickOutside = event => {
        if (this.container.current && !this.container.current.contains(event.target)) {
            this.setState({ IMDGClassdropdown: false });
            this.setState({ HAZARDNoTypedropdown: false });
            this.setState({ PackingGroupdropdown: false });
            this.setState({ IMO1dropdown: false });
            this.setState({ firecodedropdown: false });
        }
    };
    handleSubmit = () => {
        if (this.handleValidation()) {
            this.preAdvice();
        }
    }
    handleValidation() {
        let errors = {};
        let formIsValid = true;
        if (!this.state.UNNANo) {
            formIsValid = false;
            errors["UNNANo"] = Message.validation.required;
            document.getElementsByName('UNNANo')[0].style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementsByName('UNNANo')[0].style.borderColor = ColorCode.colorCode.black;
        }
        if (!this.state.IMDGClass) {
            formIsValid = false;
            errors["IMDGClass"] = Message.validation.required;
            document.getElementsByName('IMDGClass')[0].style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementsByName('IMDGClass')[0].style.borderColor = ColorCode.colorCode.black;
        }
        if (!this.state.ProperName) {
            formIsValid = false;
            errors["properName"] = Message.validation.required;
            document.getElementsByName('ProperName')[0].style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementsByName('ProperName')[0].style.borderColor = ColorCode.colorCode.black;
        }
        this.setState({ errors: errors });
        return formIsValid;
    }
    IMDGClassdata = [{ name: "xyz" }, { name: "xyz" }, { name: "xyz" }]
    HAZARDNoTypedata = [{ name: "xyz" }, { name: "xyz" }, { name: "xyz" }]
    PackingGroupdata = [{ name: "xyz" }, { name: "xyz" }, { name: "xyz" }]
    IMO1data = [{ name: "xyz" }, { name: "xyz" }, { name: "xyz" }]
    toggleDropdownIMDGClass = () => {
        this.setState({ IMDGClassdropdown: !this.state.IMDGClassdropdown });
    };
    changeRoleTypeIMDGClass = (event) => {
        const found = this.IMDGClassdata?.find((name) => {
            if (name?.name === event?.target?.innerText) {
                return name
            }
        })
        this.setState({ IMDGClass: found.name });
        this.setState({ IMDGClassdropdown: !this.state.IMDGClassdropdown });
        this.setState({
            errors: {
                ...this.state.errors,
                IMDGClass: ''
            }
        });
        document.getElementsByName('IMDGClass')[0].style.borderColor = ColorCode.colorCode.black;
    }
    toggleDropdownHAZARDNoType = () => {
        this.setState({ HAZARDNoTypedropdown: !this.state.HAZARDNoTypedropdown });
    };
    changeRoleTypeHAZARDNoType = (event) => {
        const found = this.HAZARDNoTypedata?.find((name) => {
            if (name?.name === event?.target?.innerText) {
                return name
            }
        })
        this.setState({ HAZARDNoType: found.name });
        this.setState({ HAZARDNoTypedropdown: !this.state.HAZARDNoTypedropdown });
    }
    toggleDropdownPackingGroup = () => {
        this.setState({ PackingGroupdropdown: !this.state.PackingGroupdropdown });
    };
    changeRoleTypePackingGroup = (event) => {
        const found = this.PackingGroupdata?.find((name) => {
            if (name?.name === event?.target?.innerText) {
                return name
            }
        })
        this.setState({ PackingGroup: found.name });
        this.setState({ PackingGroupdropdown: !this.state.PackingGroupdropdown });
    }
    handleChangeUNNANo = (e) => {
        this.setState({ UNNANo: e.target.value });
        this.setState({
            errors: {
                ...this.state.errors,
                UNNANo: ''
            }
        });
        document.getElementsByName('UNNANo')[0].style.borderColor = ColorCode.colorCode.black;
    }
    handleChangeProperName = (e) => {
        this.setState({ ProperName: e.target.value });
        this.setState({
            errors: {
                ...this.state.errors,
                properName: ''
            }
        });
        document.getElementsByName('ProperName')[0].style.borderColor = ColorCode.colorCode.black;
    }
    handleChangeTechnicalName = (e) => {
        this.setState({ TechnicalName: e.target.value });
    }
    handleChangeNotes = (e) => {
        this.setState({ Notes: e.target.value });
    }
    handleChangeQuantity = (e) => {
        this.setState({ Quantity: e.target.value });
    }
    handleChangeExplosiveClass = (e) => {
        this.setState({ ExplosiveClass: e.target.value });
    }
    handleChangeEmergencyContact = (e) => {
        this.setState({ EmergencyContact: e.target.value });
    }
    handleChangeInhalationZone = (e) => {
        this.setState({ InhalationZone: e.target.value });
    }
    handleChangeMFAG = (e) => {
        this.setState({ MFAG: e.target.value });
    }
    handleChangeSubstanceIDLowerPart = (e) => {
        this.setState({ SubstanceIDLowerPart: e.target.value });
    }
    handleChangeMoveMethod = (e) => {
        this.setState({ MoveMethod: e.target.value });
    }
    handleChangeIMO2 = (e) => {
        this.setState({ IMO2: e.target.value });
    }
    toggleSetLimitedQuantity = () => {
        this.setState({ LimitedQuantitycheckbox: !this.state.LimitedQuantitycheckbox });
    };
    toggleSetMarinePollutants = () => {
        this.setState({ MarinePollutantscheckbox: !this.state.MarinePollutantscheckbox });
    };
    onClickSetPlacards = () => {
        this.props.history.push('/Placards', {})
    };
    openOptionalField = () => {
        this.setState({ optionalField: !this.state.optionalField })
        if (this.state.optionalField) {
            document.getElementById('accordiandiv').style.borderBottomLeftRadius = '5px';
            document.getElementById('accordiandiv').style.borderBottomRightRadius = '5px';
        }
        else {
            document.getElementById('accordiandiv').style.borderBottomLeftRadius = '0px';
            document.getElementById('accordiandiv').style.borderBottomRightRadius = '0px';
        }
    }
    toggleDropdownIMO1 = () => {
        this.setState({ IMO1dropdown: !this.state.IMO1dropdown });
    };
    changeRoleTypeIMO1 = (event) => {
        const found = this.IMO1data?.find((name) => {
            if (name?.name === event?.target?.innerText) {
                return name
            }
        })
        this.setState({ IMO1: found.name });
        this.setState({ IMO1dropdown: !this.state.IMO1dropdown });
    }
    handleChangePackageType = (e) => {
        this.setState({ PackageType: e.target.value });
    }
    handleChangeEnterWeight = (e) => {
        this.setState({ Weight: e.target.value });
    }
    handleChangeFlashPoint = (e) => {
        this.setState({ FlashPoint: e.target.value });
    }
    handleChangeEmergencyResponseGuideNo = (e) => {
        this.setState({ EmergencyResponseGuideNo: e.target.value });
    }
    handleChangeIMDGPageNo = (e) => {
        this.setState({ IMDGPageNo: e.target.value });
    }
    handleChangeDcLgRef = (e) => {
        this.setState({ DcLgRef: e.target.value });
    }
    handleChangeEMS = (e) => {
        this.setState({ EMS: e.target.value });
    }
    handleChangeHazardIDUpperPart = (e) => {
        this.setState({ HazardIDUpperPart: e.target.value });
    }
    handleChangePlannedReferenceNo = (e) => {
        this.setState({ PlannedReferenceNo: e.target.value });
    }
    handleChangeDeckRestrictions = (e) => {
        this.setState({ DeckRestrictions: e.target.value });
    }
    handleChangeFireCode = (e) => {
        this.setState({ FireCode: e.target.value, searchfirecodelength: e?.target?.value?.length });
    }
    toggleSearchfirecode = (e) => {
        this.setState({ firecodedropdown: true });
    };
    changefirecode = (event) => {
        const found = this.state.firecodedata1?.find((name) => {
            if (name?.name === event?.target?.innerText) {
                return name
            }
        })
        this.setState({ FireCode: found.name });
        this.setState({ firecodedropdown: !this.state.firecodedropdown });
    }
    render() {
        let IMDGClassdropdownImage = this.state.IMDGClassdropdown ? <img src={arrowUp} /> : <img src={downarrow} />
        let HAZARDNoTypedropdownImage = this.state.HAZARDNoTypedropdown ? <img src={arrowUp} /> : <img src={downarrow} />
        let PackingGroupdropdownImage = this.state.PackingGroupdropdown ? <img src={arrowUp} /> : <img src={downarrow} />
        let IMO1dropdownImage = this.state.IMO1dropdown ? <img src={arrowUp} /> : <img src={downarrow} />
        if (this.state.searchfirecodelength > 0) {
            this.state.firecodedata1 = this.state.firecodedata?.filter(i => i.name?.startsWith(this.state.FireCode?.toLowerCase()))
        } else {
            this.state.firecodedata1 = [];
        }
        return (
            <div class="caacsoutercolor">
                <MetaDecorator title={TitleDescription.createAddHazardPageTitle} description={TitleDescription.createAddHazardPageDescription} />
                <Header tilesFetched={() => { }} />
                <div class="caacsnofullCreAddHazard">
                    <div id="caacsnobox1cah">
                        <nav class="caacnononavbar">
                            <div className="caacnonavbarname">
                                <small id="nonavc">Add Hazard</small>
                            </div>
                        </nav>
                        <hr class="hr1" />
                        <div class="caanotificationmaincard">
                            <div class="caaoncsdivlow1">
                                <div class="adscsdivlow2">
                                    Item Details</div>
                            </div>
                            <div class="caadivup1first">
                                <div class="caadivup4">
                                    <div class="caadivup55">
                                        <div class="caadivup3CreAddHazard">
                                            <small id="caaname">UN/NA No.</small>
                                            <div className="pass-wrapper" id="caad07" >
                                                <Input
                                                    name="UNNANo"
                                                    class="input" placeholder="Enter UN/NA No."
                                                    type="text" id="caad06" value={this.state.UNNANo}
                                                    onChange={this.handleChangeUNNANo}
                                                />
                                                <div className="createaddhazarderror11">{this.state.errors["UNNANo"]}</div>
                                            </div>
                                        </div>
                                        <div class="caadivup3CreAddHazard">
                                            <small id="caaname">IMDG Class <small class="cahrequirdot">*</small></small>
                                            <div className="pass-wrapper" id="caad07" >
                                                <Input
                                                    name="IMDGClass"
                                                    readOnly class="input" placeholder="Select IMDG Class"
                                                    type="text" id="caad066" value={this.state.IMDGClass}
                                                />
                                                <div className="createaddhazarderror11">{this.state.errors["IMDGClass"]}</div>
                                                <i id="caainput_imgAddProfile" onClick={this.toggleDropdownIMDGClass}>{IMDGClassdropdownImage}</i>
                                            </div>
                                            {this.state.IMDGClassdropdown && (
                                                <div class="caaad08" >
                                                    <div class="caadropdowncard" ref={this.container} >
                                                        {(this.IMDGClassdata?.map((name, index) => {
                                                            return (
                                                                <DropDownTable onClick={(index1) => this.changeRoleTypeIMDGClass(index1)}>
                                                                    <small class="pl-3" id="caatt2" >{name?.name} </small>
                                                                </DropDownTable>
                                                            );
                                                        }))}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div class="caadivup5">
                                        <div class="caadivup3CreAddHazard">
                                            <small id="caaname">HAZARD No. Type <small class="cahrequirdot">*</small></small>
                                            <div className="pass-wrapper" id="caad07" >
                                                <Input
                                                    readOnly class="input" placeholder="Select HAZARD No. Type"
                                                    type="text" id="caad066" value={this.state.HAZARDNoType}
                                                />
                                                <i id="caainput_imgAddProfile" onClick={this.toggleDropdownHAZARDNoType}>{HAZARDNoTypedropdownImage}</i>
                                            </div>
                                            {this.state.HAZARDNoTypedropdown && (
                                                <div class="caaad08" >
                                                    <div class="caadropdowncard" ref={this.container} >
                                                        {(this.HAZARDNoTypedata?.map((name, index) => {
                                                            return (
                                                                <DropDownTable onClick={(index1) => this.changeRoleTypeHAZARDNoType(index1)}>
                                                                    <small class="pl-3" id="caatt2" >{name?.name} </small>
                                                                </DropDownTable>
                                                            );
                                                        }))}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                        <div class="caadivup3CreAddHazard">
                                            <small id="caaname">Proper Name</small>
                                            <div className="pass-wrapper" id="caad07" >
                                                <Input
                                                    name="ProperName"
                                                    class="input" placeholder="Enter Proper Name"
                                                    type="text" id="caad06" value={this.state.ProperName}
                                                    onChange={this.handleChangeProperName}
                                                />
                                                <div className="createaddhazarderror11">{this.state.errors["properName"]}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="optionaldiv" id="accordiandiv" onClick={this.openOptionalField}>
                                <div class="optionaldivin">
                                    <small class="optionaldivtext">Optional Fields</small>
                                    <img
                                        src={this.state.optionalField ? optionalFieldup : optionalFieldDown}
                                        class="" id="droppimgg"
                                        alt="" loading="lazy"
                                    />
                                </div>
                            </div>
                            {this.state.optionalField && <div class="caadivup1second">
                                <div class="caadivup4">
                                    <div class="caadivup55">
                                        <div class="caadivup3CreAddHazard">
                                            <small id="caaname">Technical Name</small>
                                            <div className="pass-wrapper" id="caad07" >
                                                <Input
                                                    class="input" placeholder="Enter Technical Name"
                                                    type="text" id="caad06" value={this.state.TechnicalName}
                                                    onChange={this.handleChangeTechnicalName}
                                                />
                                            </div>
                                        </div>
                                        <div class="caadivup3CreAddHazard">
                                            <small id="caaname">Notes</small>
                                            <div className="pass-wrapper" id="caad07" >
                                                <Input
                                                    class="input" placeholder="Enter Notes"
                                                    type="text" id="caad06" value={this.state.Notes}
                                                    onChange={this.handleChangeNotes}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="caadivup5">
                                        <div class="caadivup3CreAddHazard">
                                            <small id="caaname">Quantity</small>
                                            <div className="pass-wrapper" id="caad07" >
                                                <Input
                                                    class="input" placeholder="Enter Quantity"
                                                    type="text" id="caad06" value={this.state.Quantity}
                                                    onChange={this.handleChangeQuantity}
                                                />
                                            </div>
                                        </div>
                                        <div class="caadivup3CreAddHazard">
                                            <small id="caaname">Packing Group</small>
                                            <div className="pass-wrapper" id="caad07" >
                                                <Input
                                                    readOnly class="input" placeholder="Select Packing Group"
                                                    type="text" id="caad066" value={this.state.PackingGroup}
                                                />
                                                <i id="caainput_imgAddProfile" onClick={this.toggleDropdownPackingGroup}>{PackingGroupdropdownImage}</i>
                                            </div>
                                            {this.state.PackingGroupdropdown && (
                                                <div class="caaad08" >
                                                    <div class="caadropdowncard" ref={this.container} >
                                                        {(this.PackingGroupdata?.map((name, index) => {
                                                            return (
                                                                <DropDownTable onClick={(index1) => this.changeRoleTypePackingGroup(index1)}>
                                                                    <small class="pl-3" id="caatt2" >{name?.name} </small>
                                                                </DropDownTable>
                                                            );
                                                        }))}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div class="caadivup5">
                                        <div class="caadivup3CreAddHazard">
                                            <small id="caaname">Explosive Class</small>
                                            <div className="pass-wrapper" id="caad07" >
                                                <Input
                                                    class="input" placeholder="Enter Explosive Class"
                                                    type="text" id="caad06" value={this.state.ExplosiveClass}
                                                    onChange={this.handleChangeExplosiveClass}
                                                />
                                            </div>
                                        </div>
                                        <div class="caadivup3CreAddHazard">
                                            <small id="caaname">Emergency Contact</small>
                                            <div className="pass-wrapper" id="caad07" >
                                                <Input
                                                    class="input" placeholder="Enter Emergency Contact"
                                                    type="text" id="caad06" value={this.state.EmergencyContact}
                                                    onChange={this.handleChangeEmergencyContact}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="caadivup5">
                                        <div class="caadivup3CreAddHazardchack">
                                            <img
                                                src={this.state.LimitedQuantitycheckbox ? uncheckedbox : checkedbox}
                                                class="mr-2" id="cahcheckimg"
                                                alt="" loading="lazy"
                                                onClick={this.toggleSetLimitedQuantity}
                                            />
                                            <small class="cahcheckboxtext">Limited Quantity</small>
                                        </div>
                                        <div class="caadivup3CreAddHazard">
                                            <img
                                                src={this.state.MarinePollutantscheckbox ? uncheckedbox : checkedbox}
                                                class="mr-2" id="cahcheckimg"
                                                alt="" loading="lazy"
                                                onClick={this.toggleSetMarinePollutants}
                                            />
                                            <small class="cahcheckboxtext">Marine Pollutants</small>
                                        </div>
                                    </div>
                                    <div class="caadivup5">
                                        <div class="caadivup3CreAddHazard">
                                            <small id="caaname">Inhalation Zone</small>
                                            <div className="pass-wrapper" id="caad07" >
                                                <Input
                                                    class="input" placeholder="Enter Inhalation Zone"
                                                    type="text" id="caad06" value={this.state.InhalationZone}
                                                    onChange={this.handleChangeInhalationZone}
                                                />
                                            </div>
                                        </div>
                                        <div class="caadivup3CreAddHazard">
                                            <small id="caaname">MFAG</small>
                                            <div className="pass-wrapper" id="caad07" >
                                                <Input
                                                    class="input" placeholder="Enter MFAG"
                                                    type="text" id="caad06" value={this.state.MFAG}
                                                    onChange={this.handleChangeMFAG}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="caadivup5">
                                        <div class="caadivup3CreAddHazard">
                                            <small id="caaname">Substance ID, Lower Part</small>
                                            <div className="pass-wrapper" id="caad07" >
                                                <Input
                                                    class="input" placeholder="Enter Substance ID, Lower Part"
                                                    type="text" id="caad06" value={this.state.SubstanceIDLowerPart}
                                                    onChange={this.handleChangeSubstanceIDLowerPart}
                                                />
                                            </div>
                                        </div>
                                        <div class="caadivup3CreAddHazard">
                                            <small id="caaname">Move Method</small>
                                            <div className="pass-wrapper" id="caad07" >
                                                <Input
                                                    class="input" placeholder="Enter Move Method"
                                                    type="text" id="caad06" value={this.state.MoveMethod}
                                                    onChange={this.handleChangeMoveMethod}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="caadivup5">
                                        <div class="caadivup3CreAddHazard">
                                            <small id="caaname">IMO2</small>
                                            <div className="pass-wrapper" id="caad07" >
                                                <Input
                                                    class="input" placeholder="Enter IMO2"
                                                    type="text" id="caad06" value={this.state.IMO2}
                                                    onChange={this.handleChangeIMO2}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="caadivup5placard">
                                        <div class="caadivup3CreAddHazardplac" onClick={this.onClickSetPlacards}>
                                            <small class="cahSetPlacards">Set Placards</small>
                                            <img
                                                src={rightarrow}
                                                class="ml-2 mb-1" id="cahSetPlacardsimg"
                                                alt="" loading="lazy"
                                            />
                                        </div>
                                    </div>
                                    <div class="caadivup55">
                                        <div class="caadivup3CreAddHazard">
                                            <small id="caaname">Package Type</small>
                                            <div className="pass-wrapper" id="caad07" >
                                                <Input
                                                    class="input" placeholder="Enter Package Type"
                                                    type="text" id="caad06" value={this.state.PackageType}
                                                    onChange={this.handleChangePackageType}
                                                />
                                                <div className="createaddhazardpreviewerror1">{this.state.errors["packageType"]}</div>
                                            </div>
                                        </div>
                                        <div class="caadivup3CreAddHazard">
                                            <small id="caaname">Weight (kg)</small>
                                            <div className="pass-wrapper" id="caad07" >
                                                <Input
                                                    class="input" placeholder="Enter Weight"
                                                    type="text" id="caad06" value={this.state.Weight}
                                                    onChange={this.handleChangeEnterWeight}
                                                />
                                                <div className="createaddhazardpreviewerror1">{this.state.errors["weight"]}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="caadivup5">
                                        <div class="caadivup3CreAddHazard">
                                            <small id="caaname">Flash Point (C)</small>
                                            <div className="pass-wrapper" id="caad07" >
                                                <Input
                                                    class="input" placeholder="Enter Flash Point"
                                                    type="text" id="caad06" value={this.state.FlashPoint}
                                                    onChange={this.handleChangeFlashPoint}
                                                />
                                                <div className="createaddhazardpreviewerror1">{this.state.errors["flashPoint"]}</div>
                                            </div>
                                        </div>
                                        <div class="caadivup3CreAddHazard">
                                            <small id="caaname">Emergency Response Guide No.</small>
                                            <div className="pass-wrapper" id="caad07" >
                                                <Input
                                                    class="input" placeholder="Enter Emergency Response Guide No."
                                                    type="text" id="caad06" value={this.state.EmergencyResponseGuideNo}
                                                    onChange={this.handleChangeEmergencyResponseGuideNo}
                                                />
                                                <div className="createaddhazardpreviewerror1">{this.state.errors["emergencyResponseGuideNo"]}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="caadivup5">
                                        <div class="caadivup3CreAddHazard">
                                            <small id="caaname">IMDG Page No.</small>
                                            <div className="pass-wrapper" id="caad07" >
                                                <Input
                                                    class="input" placeholder="Enter IMDG Page No."
                                                    type="text" id="caad06" value={this.state.IMDGPageNo}
                                                    onChange={this.handleChangeIMDGPageNo}
                                                />
                                                <div className="createaddhazardpreviewerror1">{this.state.errors["IMDGPageNo"]}</div>
                                            </div>
                                        </div>
                                        <div class="caadivup3CreAddHazard">
                                            <small id="caaname">DcLgRef</small>
                                            <div className="pass-wrapper" id="caad07" >
                                                <Input
                                                    class="input" placeholder="Enter DcLgRef"
                                                    type="text" id="caad06" value={this.state.DcLgRef}
                                                    onChange={this.handleChangeDcLgRef}
                                                />
                                                <div className="createaddhazardpreviewerror1">{this.state.errors["DcLgRef"]}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="caadivup5">
                                        <div class="caadivup3CreAddHazard">
                                            <small id="caaname">EMS</small>
                                            <div className="pass-wrapper" id="caad07" >
                                                <Input
                                                    class="input" placeholder="Enter EMS"
                                                    type="text" id="caad06" value={this.state.EMS}
                                                    onChange={this.handleChangeEMS}
                                                />
                                                <div className="createaddhazardpreviewerror1">{this.state.errors["EMS"]}</div>
                                            </div>
                                        </div>
                                        <div class="caadivup3CreAddHazard">
                                            <small id="caaname">Hazard ID, Upper Part</small>
                                            <div className="pass-wrapper" id="caad07" >
                                                <Input
                                                    class="input" placeholder="Enter Hazard ID, Upper Part"
                                                    type="text" id="caad06" value={this.state.HazardIDUpperPart}
                                                    onChange={this.handleChangeHazardIDUpperPart}
                                                />
                                                <div className="createaddhazardpreviewerror1">{this.state.errors["hazardIDUpperPart"]}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="caadivup5">
                                        <div class="caadivup3CreAddHazard">
                                            <small id="caaname">Planned Reference No.</small>
                                            <div className="pass-wrapper" id="caad07" >
                                                <Input
                                                    class="input" placeholder="Enter Planned Reference No."
                                                    type="text" id="caad06" value={this.state.PlannedReferenceNo}
                                                    onChange={this.handleChangePlannedReferenceNo}
                                                />
                                                <div className="createaddhazardpreviewerror1">{this.state.errors["plannedReferenceNo"]}</div>
                                            </div>
                                        </div>
                                        <div class="caadivup3CreAddHazard">
                                            <small id="caaname">IMO1</small>
                                            <div className="pass-wrapper" id="caad07" >
                                                <Input
                                                    readOnly class="input" placeholder="Select IMO1"
                                                    type="text" id="caad066" value={this.state.IMO1}
                                                />
                                                <div className="createaddhazardpreviewerror1">{this.state.errors["IMO1"]}</div>
                                                <i id="caainput_imgAddProfile" onClick={this.toggleDropdownIMO1}>{IMO1dropdownImage}</i>
                                            </div>
                                            {this.state.IMO1dropdown && (
                                                <div class="caaad08" >
                                                    <div class="caadropdowncard" ref={this.container} >
                                                        {(this.IMO1data?.map((name, index) => {
                                                            return (
                                                                <DropDownTable onClick={(index1) => this.changeRoleTypeIMO1(index1)}>
                                                                    <small class="pl-3" id="caatt2" >{name?.name} </small>
                                                                </DropDownTable>
                                                            );
                                                        }))}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div class="caadivup5">
                                        <div class="caadivup3CreAddHazard">
                                            <small id="caaname">Deck Restrictions</small>
                                            <div className="pass-wrapper" id="caad07" >
                                                <Input
                                                    class="input" placeholder="Enter Deck Restrictions"
                                                    type="text" id="caad06" value={this.state.DeckRestrictions}
                                                    onChange={this.handleChangeDeckRestrictions}
                                                />
                                                <div className="createaddhazardpreviewerror1">{this.state.errors["deckRestrictions"]}</div>
                                            </div>
                                        </div>
                                        <div class="caadivup3CreAddHazard">
                                            <small id="caaname">Fire Code</small>
                                            <div className="pass-wrapper" id="caad07" >
                                                <Input
                                                    class="input" placeholder="Enter Fire Code"
                                                    type="text" id="caad06" value={this.state.FireCode}
                                                    onChange={this.handleChangeFireCode}
                                                    onKeyPress={this.toggleSearchfirecode}
                                                />
                                                <div className="createaddhazardpreviewerror1">{this.state.errors["fireCode"]}</div>
                                                <img id="caasinput_imgAddProfile" src={search}></img>
                                            </div>
                                            {this.state.firecodedropdown && (
                                                <div class="caaad08" >
                                                    <div class="caadropdowncard" ref={this.container} >
                                                        {(this.state.firecodedata1?.map((name, index) => {
                                                            return (
                                                                <DropDownTable onClick={(index1) => this.changefirecode(index1)}>
                                                                    <small class="pl-3" id="caatt2" >{name?.name} </small>
                                                                </DropDownTable>
                                                            );
                                                        }))}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>}
                            <div class="caabuttdiv">
                                <Button class="caabuttdiv1" onClick={this.handleSubmit}>
                                    <small class="caabuttdiv2">Continue</small>
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="caanotifooter01cahaz">
                    <Footer />
                </div>
                <div class="caanotifooter02cahaz">
                    <Footer2 />
                </div>
            </div>
        );
    }
}
export default CreateAddHazard;